import { useNavigate } from '@tanstack/react-router';
import { Button } from 'components/Button';
import { useSelfExclusion } from 'pages/PlayResponsabilityPage/partials/SEU/self-exclusion/hooks/use-self-exclusion';
import DepositUnavailableAfter24hBreakModalLoadable from 'pages/PlayResponsabilityPage/partials/SEU/take-a-break/components/deposit-unavailable-modal/deposit-unavailable-modal.loadable';
import { useState } from 'react';
import { Translate } from 'react-localize-redux';
import useGetTranslate from 'utils/hooks/useGetTranslate';
import { RechargeButtonProps } from './manage-balance-buttons.config';

export default function RechargeButton({ id, onClick }: RechargeButtonProps) {
  const navigate = useNavigate();
  const translate = useGetTranslate();
  const [openModal, setOpenModal] = useState(false);
  const { has24hSinceStart, isSelfExclusionActive } = useSelfExclusion();

  const handleClick = () => {
    if (!has24hSinceStart && isSelfExclusionActive) {
      setOpenModal(true);
    } else {
      onClick?.();
      navigate({ to: '/topup' });
    }
  };

  return (
    <>
      <Button id={id} onClick={handleClick} minWidth={'18px'} flex={'1 1 auto'}>
        <Translate id="lbl.modalrecharge.recharge" />
      </Button>
      {openModal && (
        <DepositUnavailableAfter24hBreakModalLoadable
          heading={translate(
            'text.modal.depositUnavailable.24h.activeBreak.header',
          )}
          onClose={() => {
            setOpenModal(false);
          }}
          closeBtn={false}
        />
      )}
    </>
  );
}
